import React from 'react';
import RaceCalendar from '../components/RaceCalendar';
import { Calendar as CalendarIcon } from 'lucide-react';

const Kalender = () => {
  return (
    <div className="min-h-screen bg-background py-8">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-8">
          <div className="inline-block bg-[#FDB913] rounded-full p-4 mb-4">
            <CalendarIcon size={40} className="text-[#1a2332]" />
          </div>
          <h1 className="text-4xl font-bold text-foreground mb-2">Racekalender 2026</h1>
          <p className="text-muted-foreground">Alle races en tijden voor het seizoen 2026</p>
        </div>

        <RaceCalendar />
      </div>
    </div>
  );
};

export default Kalender;
